export function makeProducts(payload) {
  return payload.map(product => makeProduct(product));
}

export function makeProduct(payload) {
  return new Product(payload.id, payload.name, payload.code);
}

class Product {
  constructor(id, name, code) {
    this.id = +id;
    this.username = name;
    this.code = code;
  }
}

export default Product;



// WEBPACK FOOTER //
// ./client/app/shared/models/product.model.js